<div class="d-flex align-items-center py-2 px-3 cursor-pointer" (click)="selected = !selected; emitValueSelected()">
  <input class="form-check-input m-0 me-1" type="checkbox" [(ngModel)]="selected" style="cursor: pointer"
         (ngModelChange)="emitValueSelected()">
  <label class="d-flex flex-grow-1" style="cursor: pointer">
    <span class="text-truncate py-1">{{formattedFacetName}}</span>
    <span class="text-secondary ms-1 py-1">({{count}})</span>
  </label>
</div>
